// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-z7x","tabsBox":"styles_tabsBox__4kXWt","createButton":"styles_createButton__3mRRS"};